import { render, staticRenderFns } from "./OrganizationUnitDialog.vue?vue&type=template&id=243fc689&scoped=true"
import script from "./OrganizationUnitDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationUnitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fc689",
  null
  
)

export default component.exports